import { render } from "./RoofTypeSelect.vue?vue&type=template&id=88b42f68&scoped=true"
import script from "./RoofTypeSelect.vue?vue&type=script&lang=js"
export * from "./RoofTypeSelect.vue?vue&type=script&lang=js"

import "./RoofTypeSelect.vue?vue&type=style&index=0&id=88b42f68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b42f68"]])

export default __exports__